import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FAQsHero } from '../components/faqs/FAQsHero';
import { FAQList } from '../components/faqs/FAQList';
export function FAQsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-862">
      <Header data-id="element-863" />

      <main className="pt-20" data-id="element-864">
        <FAQsHero data-id="element-865" />
        <FAQList data-id="element-866" />
      </main>

      <Footer data-id="element-867" />
    </div>;
}